module.exports = __webpack_public_path__ + "img/1.77515136.jpg";